import { render, staticRenderFns } from "./ComprehensivePrivacyNotice.vue?vue&type=template&id=f47721a6&scoped=true"
import script from "./ComprehensivePrivacyNotice.vue?vue&type=script&lang=js"
export * from "./ComprehensivePrivacyNotice.vue?vue&type=script&lang=js"
import style0 from "./ComprehensivePrivacyNotice.vue?vue&type=style&index=0&id=f47721a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47721a6",
  null
  
)

export default component.exports